var map = {
	"./headerJson_hk_en": 77932,
	"./headerJson_hk_en.js": 77932,
	"./headerJson_hk_tc": 30038,
	"./headerJson_hk_tc.js": 30038,
	"./headerJson_id_en": 17747,
	"./headerJson_id_en.js": 17747,
	"./headerJson_id_id": 45973,
	"./headerJson_id_id.js": 45973,
	"./headerJson_my_bm": 20639,
	"./headerJson_my_bm.js": 20639,
	"./headerJson_my_en": 46079,
	"./headerJson_my_en.js": 46079,
	"./headerJson_th_en": 88391,
	"./headerJson_th_en.js": 88391,
	"./headerJson_th_th": 53402,
	"./headerJson_th_th.js": 53402,
	"./headerJson_vn_en": 67277,
	"./headerJson_vn_en.js": 67277,
	"./headerJson_vn_vi": 41087,
	"./headerJson_vn_vi.js": 41087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74176;